<template>
    <NavBar></NavBar>
    <div v-if="globe" class="container-fluid">
        <div class="row globe-row">
            <div class="col-md-6 image-col">
                <img v-for="image in globe.full_images" v-if="globe.full_images.length == 1" v-bind:key="image.id" v-bind:src="require('@/assets/globes/'+ globe.folder + '/' + image)" class="globe-img">
                <div v-else id="carousel" class="carousel slide">
                    <div class="carousel-inner">
                        <div v-for="(image, index) in globe.full_images" v-bind:key="index" :class = "(index == 0) ? 'carousel-item active':'carousel-item'" :id="index">
                            <img class="globe-img" v-bind:src="require('@/assets/globes/'+ globe.folder + '/' + image)">
                        </div>
                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#carousel" data-bs-slide="prev">
                        <span class="prev-icon" aria-hidden="true">&larr;</span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carousel" data-bs-slide="next">
                        <span class="next-icon" aria-hidden="true">&rarr;</span>
                        <span class="visually-hidden">Next</span>
                    </button>
                </div>
            </div>
            <div class="col-md-6 desc-col">
                <p class="globe-name">{{globe.name}}</p>
                <p class="globe-author">{{globe.author}} | <b class="globe-date">{{globe.date}}</b></p>
                <!--<p class="globe-desc" v-html="globe.desc"></p>
                <p v-if="globe.image_desc" v-for="desc in globe.image_desc" class="globe-img-desc" v-html="desc"></p>-->
                <a class="globe_link" :href="globe.link">Link to full Patent Report</a>
                <div class="globe-button-container">
                    <router-link class="grid-link" :to="('globe_' + prevGlobe)">
                        <button class="globe-button">
                            Previous Globe
                        </button>
                    </router-link>
                    <router-link class="grid-link" :to="('globe_' + nextGlobe)">
                        <button class="globe-button">
                            Next Globe
                        </button>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import NavBar from "../components/NavBar.vue"

  export default {
    name: 'GlobeInfo',
    components: {
        NavBar
    },
    data(){
        return{
            globe:null,
            nextGlobe:null,
            prevGlobe:null
        }
    },
    created(){
        this.fetchData();
    },
    watch:{
        '$route':'fetchData'
    },
    methods:{
        fetchData(){
            let self = this;

            var fileName = "./globes.json";
            const myRequest = new Request(fileName);

            var globe_num = parseInt(this.$route.params.globe.replace(/[^0-9]/g,''));

            fetch(myRequest)
                .then( res => res.json())
                .then(data => {
                    let max = data.globes.length - 1;
                    data.globes.forEach(function(g){
                        if (g.id == globe_num){
                            self.globe = g;
                        }
                    })
                    self.nextGlobe = globe_num < max ? globe_num + 1: 0;
                    self.prevGlobe = globe_num > 0 ? globe_num - 1: max;
                })
                .catch(function(error) {
                    console.log('Request failed', error)
                });
        }
    }
  }
</script>

<style scoped>
    .container-fluid{
        height:100vh;
    }
    .globe-row{
        padding-top:10px;
    }
   .desc-col{
        overflow-y:scroll;
    }
    .image-col{
        position: sticky;
        top: 0;
    }
    .globe-img{
        width:100%;
    }
    .globe-name{
        font-size:48px;
        margin-bottom:0;
        font-weight:bold;
        text-transform: uppercase;
    }   
    .globe-author{
        font-size:24px;
        margin-top:0;
    }
    .globe-date{
        font-size:24px;
        font-style:italic;
    }
    .globe-desc{
        text-align:justify;
        padding-right:10px;
    }
    .globe-img-desc{
        font-weight:bold;
    }
    .prev-icon, .next-icon{
        color:black;
        font-size: 50px;
    }
    .carousel-control-prev, .carousel-control-next{
        background-color:rgba(0,0,0,0);
    }
    .carousel-control-prev:hover, .carousel-control-next:hover{
        background-color:rgba(0,0,0,0.2);
    }
    .globe-button-container{
        margin-top:15px;
    }
</style>